import { RefObject } from 'react';
import { Box, CircularProgress } from '@mui/material';

import { CaseHistoryResponseDto } from '@bandido/shared/dtos';

import { MessageRenderer } from './components/MessageRenderer';
import { LoadingState } from './components/LoadingState';
import { MessageGroup } from './helpers';

interface CaseContentHistoryMobileProps {
  // Data
  groupedMessages: MessageGroup[];
  isFetchingNextPage: boolean;
  isLoading: boolean;

  // Refs for intersection observer
  topRef: RefObject<HTMLDivElement>;

  // Callbacks
  isCurrentUser: (history: CaseHistoryResponseDto) => boolean;
}

export const CaseContentHistoryMobile: React.FC<CaseContentHistoryMobileProps> = ({
  groupedMessages,
  isFetchingNextPage,
  isLoading,
  topRef,
  isCurrentUser,
}) => {
  if (isLoading) {
    return <LoadingState />;
  }

  return (
    <Box
      sx={{
        height: '100%',
        overflow: 'auto',
        padding: 2,
        gap: 3,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box ref={topRef} sx={{ height: 20, width: '100%' }} />
      
      {isFetchingNextPage && (
        <Box display="flex" justifyContent="center" p={2}>
          <CircularProgress size={24} />
        </Box>
      )}

      {groupedMessages.map((group, index) => {
        const previousGroup = index > 0 ? groupedMessages[index - 1] : null;
        const previousDate = previousGroup ? previousGroup.messages[0].createdAt : null;

        return (
          <MessageRenderer
            key={group.messages[0].id}
            group={group}
            lastMessageDate={previousDate}
            isCurrentUser={isCurrentUser}
          />
        );
      })}
    </Box>
  );
};